(() => {
  const answers = {
    shipping: 'Shipping options and estimated delivery times are shown at checkout. For help with an order already placed, choose “Order help” and include your order number when contacting us.',
    order: 'For an order update, please use “Contact a person” below and include your order number plus the email used at checkout.',
    care: 'For everyday care, gently spot clean the affected area, avoid machine washing, reshape the bag, and let it air dry away from direct heat.',
    returns: 'Return or exchange eligibility can vary by item. Please contact us before sending anything back so our team can confirm the next step.',
    custom: 'Loop Studio pieces are made in small batches. For a color, size, or custom request, use “Contact a person” and tell us what you have in mind.',
    fallback: 'I can help with shipping, order questions, bag care, returns, and custom requests. For anything else, choose “Contact a person” below.'
  };

  const topicLabels = {
    shipping: 'Shipping & delivery',
    order: 'Order help',
    care: 'Bag care',
    returns: 'Returns & exchanges',
    custom: 'Custom requests'
  };

  const findTopic = (question) => {
    const text = question.toLowerCase();

    if (/ship|deliver|postage|arriv|tracking/.test(text)) return 'shipping';
    if (/order|status|where|cancel|address/.test(text)) return 'order';
    if (/care|clean|wash|stain|dry/.test(text)) return 'care';
    if (/return|exchange|refund/.test(text)) return 'returns';
    if (/custom|colour|color|size|personal|bespoke/.test(text)) return 'custom';
    return 'fallback';
  };

  document.querySelectorAll('[data-loop-support]').forEach((widget) => {
    const toggle = widget.querySelector('[data-loop-support-toggle]');
    const close = widget.querySelector('[data-loop-support-close]');
    const panel = widget.querySelector('[data-loop-support-panel]');
    const conversation = widget.querySelector('[data-loop-support-conversation]');
    const form = widget.querySelector('[data-loop-support-form]');
    const input = form && form.querySelector('input');

    if (!toggle || !close || !panel || !conversation || !form || !input) return;

    const setOpen = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) input.focus();
      else toggle.focus();
    };

    const addMessage = (text, sender) => {
      const message = document.createElement('div');
      message.className = `loop-support__message loop-support__message--${sender}`;
      message.textContent = text;
      conversation.appendChild(message);
      conversation.scrollTop = conversation.scrollHeight;
    };

    const answerTopic = (topic, question) => {
      addMessage(question || topicLabels[topic] || 'Support question', 'user');
      window.setTimeout(() => addMessage(answers[topic] || answers.fallback, 'bot'), 180);
    };

    toggle.addEventListener('click', () => setOpen(panel.hidden));
    close.addEventListener('click', () => setOpen(false));

    widget.querySelectorAll('[data-loop-topic]').forEach((button) => {
      button.addEventListener('click', () => {
        const topic = button.dataset.loopTopic;
        answerTopic(topic, topicLabels[topic]);
      });
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (!question) return;
      input.value = '';
      answerTopic(findTopic(question), question);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) setOpen(false);
    });
  });
})();
